import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const Telefono1FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TELÉFONO 1' htmlFor='input-telefono1' md={2} />
      <Col md={10}>
        <Field name='telefono1'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-telefono1'
              placeholder='Ingresar telefono ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(Telefono1FormGroup)
